import React from 'react'
import { Layout } from 'antd'
import classNames from 'classnames'
import TopBar from 'components/swifteq/layout/TopBar'
import style from './style.module.scss'
import { isIframe } from '../../services/utils'

const MainV2Layout = ({
                      children,
                    }) => {
  return (
    <div>
      <Layout
        className={classNames({
          cui__layout__borderless: true,
        })}
      >
        <Layout>
          <Layout.Header
            className={'cui__layout__header'}
          >
            <TopBar />
          </Layout.Header>
          <Layout.Content>
            <div
              className={classNames(
                'cui__utils__content',
                isIframe() ? style.containerIframe : style.containerInner,
              )}
            >
              {children}
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    </div>
  )
}

export default MainV2Layout
